import { HttpClient } from '@descope/core-js-sdk';
import withUser from './user';
import withProject from './project';
import withTenant from './tenant';
import withJWT from './jwt';
import withPermission from './permission';
import withRole from './role';
import withGroup from './group';
import withSSOSettings from './sso';
import withAccessKey from './accesskey';
import WithFlow from './flow';
import WithTheme from './theme';
import WithAudit from './audit';
import WithAuthz from './authz';
import withSSOApplication from './ssoapplication';
import withPassword from './password';
import WithFGA from './fga';
import withInboundApplication from './inboundapplication';
import withOutboundApplication from './outboundapplication';
import withDescoper from './descoper';
import withManagementKey from './managementKey';
import withEngine from './engine';
import withList from './list';
import withJWTTemplate from './jwttemplate';
import withScopeClaimMapping from './scopeclaimmapping';
import withAnalytics from './analytics';
import { FGAConfig } from './types';

/** Constructs a higher level Management API that wraps the functions from code-js-sdk */
const withManagement = (client: HttpClient, fgaConfig?: FGAConfig) => ({
  user: withUser(client),
  project: withProject(client),
  accessKey: withAccessKey(client),
  tenant: withTenant(client),
  ssoApplication: withSSOApplication(client),
  inboundApplication: withInboundApplication(client),
  outboundApplication: withOutboundApplication(client),
  sso: withSSOSettings(client),
  jwt: withJWT(client),
  permission: withPermission(client),
  password: withPassword(client),
  role: withRole(client),
  group: withGroup(client),
  flow: WithFlow(client),
  theme: WithTheme(client),
  audit: WithAudit(client),
  authz: WithAuthz(client, fgaConfig),
  fga: WithFGA(client, fgaConfig),
  descoper: withDescoper(client),
  managementKey: withManagementKey(client),
  engine: withEngine(client),
  list: withList(client),
  jwtTemplate: withJWTTemplate(client),
  scopeClaimMapping: withScopeClaimMapping(client),
  analytics: withAnalytics(client),
});

export default withManagement;
